<template>
	<page>
		<module enable-flex>
			<m-search ref="search" @search="searchHandle">
				<c-form ref="searchForm">
					<c-form-item type="hidden" name="stationed_id"></c-form-item>
					<c-form-item type="input" label="所属商家" name="company_name" readonly @click="$refs.stationedSelector.open()"></c-form-item>
					<c-form-item type="input" label="提现单号" name="apply_number"></c-form-item>
					<c-form-item type="datetime" label="申请时间" start-name="begin_time" end-name="end_date"></c-form-item>
					<c-form-item type="input" label="提现账号" name="bank_card"></c-form-item>
					<c-form-item type="select" label="到账渠道" name="withdraw_channel" :options="WithdrawChannel" ></c-form-item>
					<c-form-item type="checkbox" label="状态" name="state" :options="State" ></c-form-item>
				</c-form>
			</m-search>
			
			<c-table ref="table" code="stationed_account_extract_list">
				<c-table-column
					label="提现单号"
					name="apply_number"
					width="130"
				></c-table-column>
				
				<c-table-column
					label="状态"
					name="state"
					width="80"
				>
					<template v-slot="{data}">
						<span style="color:coral" v-if="data.state==1">{{stateName[data.state]}}</span>
						<span style="color:dodgerblue" v-if="data.state==2">{{stateName[data.state]}}</span>
						<span style="color:dodgerblue" v-if="data.state==3">{{stateName[data.state]}}</span>
						<span style="color:green" v-if="data.state==4">{{stateName[data.state]}}</span>
						<span style="color:red" v-if="data.state==5">{{stateName[data.state]}}</span>
						<span style="color:gray" v-if="data.state==10">{{stateName[data.state]}}</span>
					</template>
				</c-table-column>
				
				<c-table-column
					label="商家"
					name="stationed_name"
					width="160"
				></c-table-column>

				<c-table-column
					label="提现金额"
					name="extract_money"
					width="90"
				>
				  <template v-slot="{data}">
					<span style="color:dodgerblue" v-if="data.extract_money && data.extract_money>0">￥{{data.extract_money.toFixed(2)}}</span>
					<span v-else>--</span>
				  </template>
				</c-table-column>
				
				<c-table-column
					label="提现手续费"
					name="withdraw_fee"
					width="90"
				>
					<template v-slot="{data}">
						<span style="color:dodgerblue" v-if="data.withdraw_fee && data.withdraw_fee>0">￥{{data.withdraw_fee.toFixed(2)}}</span>
						<span v-else>无</span>
					</template>
				</c-table-column>
		
				<c-table-column
					label="申请时间"
					name="apply_date"
					width="140"
				></c-table-column>
		
				<c-table-column
					label="提现账号"
					name="withdraw_account_number"
					width="380"
				>
					<template v-slot="{data}">
						{{withdrawAccountNumber(data)}}
					</template>
				</c-table-column>
				
				<!-- <c-table-column
					label="备注"
					name="remark"
					width="200"
				></c-table-column> -->
		
				<c-table-column
					label="申请人姓名"
					name="apply_user_realname"
					width="90"
				></c-table-column>
		
				<c-table-column
					label="申请时间"
					name="apply_date"
					width="140"
				></c-table-column>
				
				<c-table-column
					type="button"
					fixed="right"
					label="操作"
					width="115"
				>
					<template v-slot="{data}">
						<c-table-button @click="navigateTo(`/stationed_account_extract_detail/${data.id}`)">查看</c-table-button>
						<c-table-button v-if="data.state == 1" power="b_stationed_account_extract_approval" @click="navigateTo(`/stationed_account_extract_detail/${data.id}`)">审批</c-table-button>
						<c-table-button v-if="data.state == 2" power="b_stationed_account_extract_pay" @click="navigateTo(`/stationed_account_extract_detail/${data.id}`)">打款</c-table-button>
					</template>
				</c-table-column>
			</c-table>
		</module>
		<stationed-selector ref="stationedSelector" @resolve="selectStationed"></stationed-selector>
	</page>
</template>

<script>
	import stationedSelector from '@/components/service/stationed_selector.vue'  // 商家库
	export default {
		name: 'm_stationed_account_extract',
		
		// 第二步：定义组件，导入了哪些就定义哪些
		components: {
			stationedSelector
		},
		
		data() {
			return {
				stateName: {
					1: '待审批',
					2: '待打款',
					3: '待到账',
					4: '打款到帐',
					5: '打款失败',
					10: '审批驳回'
				},
				State: [{
						name: '待审批',
						value: 1
					},{
						name: '待打款',
						value: 2
					// },{
					// 	name: '待到账',
					// 	value: 3
					},{
						name: '打款到帐',
						value: 4
					// },{
					// 	name: '打款失败',
					// 	value: 5
					},{
						name: '审批驳回',
						value: 10
					}
				],
				WithdrawChannel: [{
						name: '全部',
						value: 0
					},{
						name: '银行卡',
						value: 1
					},{
						name: '支付宝',
						value: 2
					},{
						name: '微信',
						value: 3
					},
				]
			}
		},
		
		mounted() {
			this.$refs.search.search();
			this.$bus.$on('stationed_account_extract.update', data => {
				// 刷新列表
				this.$refs.table.update();
			});

		},
		
		methods: {
			searchHandle(data) {
				data.stationed_type = 1;
				this.$refs.table.load({
					url: '/stationed/extract/list',
					data
				});
			},
			withdrawAccountNumber(data) {
				if(data.withdraw_channel == 1){
					return data.account_name + '（银行卡：' + data.bank_name + ',' +  data.account_name + ',' + data.bank_card+'）';
				}else if(data.withdraw_channel == 2){
					return data.withdraw_account_number+'（支付宝）';
				}else if(data.withdraw_channel == 3){
					return data.withdraw_account_number+'（微信）' ;
				}else if(data.withdraw_channel == 4){
					return '（平台账户）' ;
				}else{
					return '--'
				}
			},
			selectStationed(data) {
				this.$refs.searchForm.set({
					stationed_id: data[0].id,
					company_name: data[0].company_name
				});
			}
		}
	}
</script>